import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ViewportLoader } from '@/components/Loading';
import OrderDetailsHeader from './-components/OrderDetailsHeader';
import { useSentOrderDetailQuery } from './-query/api';
export const Route = createFileRoute('/_staff/marketplace/sent-orders/$orderId/_layout')({
  component: OrderDetailLayout
});
function OrderDetailLayout() {
  const {
    orderId
  } = Route.useParams();
  const {
    data: order,
    isLoading
  } = useSentOrderDetailQuery(orderId);
  if (isLoading) return <ViewportLoader />;
  if (!order) return null;
  return <div className="min-h-screen">
      <OrderDetailsHeader orderDescription={order} />
      <Outlet />
    </div>;
}